export const timeToRead = wordsCount => {
  const WORDS_PER_MINUTE = 200;
  return Math.ceil(wordsCount / WORDS_PER_MINUTE);
};
